/**
 * Renter-facing failure copy.
 *
 * The per-reason message matrix was deleted (ENG-3331): the backend now stores
 * ONE generated string on `RenterFile.error_message` (rendered via
 * `utils/renderErrorCopy.tsx`). This module keeps only the generic fallback
 * used when a failed file has no stored copy.
 */
export const GENERIC_ERROR_COPY =
  'This document did not pass our checks. Please upload a new copy.';
